import cookieManager from "./cookie.js"
import type { CachedUser } from "#/types.js"

const _CACHED_ME_KEY = "shortTermAuth"
const _SESSION_ID_KEY = "sessionId"

export const getCachedMe = (): CachedUser | null => JSON.parse(localStorage.getItem(_CACHED_ME_KEY) ?? "null")

export const setCachedMe = (me: string): void => localStorage.setItem(_CACHED_ME_KEY, me)

export const clearAuthUser = (): void => {
    removeSessionId()
    localStorage.removeItem(_CACHED_ME_KEY)
}

export const getSessionId = (): string | undefined => cookieManager.get(_SESSION_ID_KEY)

export const setSessionId = (sessionId: string): void => cookieManager.set(_SESSION_ID_KEY, sessionId)

export const removeSessionId = (): void => cookieManager.remove(_SESSION_ID_KEY)
